module.exports = __webpack_public_path__ + "static/media/method-3d-mob.7770cea1.png";